import { useState } from 'react';
import { StoryConfig } from '@/lib/themeConfig';
import { SaveButton } from './GeneralSection';
import ImageUploader from '../ImageUploader';

interface Props { data: StoryConfig; onChange: (data: StoryConfig) => void; }

export default function StorySection({ data, onChange }: Props) {
  const [local, setLocal] = useState<StoryConfig>(data);
  const [saved, setSaved] = useState(false);
  const u = (key: keyof StoryConfig, val: string) => setLocal(p => ({ ...p, [key]: val }));
  const handleSave = () => { onChange(local); setSaved(true); setTimeout(() => setSaved(false), 2000); };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white rounded-2xl p-6 space-y-4">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Hikayemiz Bölümü</h2>
        <div className="grid grid-cols-2 gap-4">
          <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Rozet</label><input type="text" value={local.badge} onChange={e => u('badge', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
          <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Kuruluş Yılı</label><input type="text" value={local.founded_year} onChange={e => u('founded_year', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
        </div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Başlık</label><textarea value={local.title} onChange={e => u('title', e.target.value)} rows={2} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none" /></div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">1. Paragraf</label><textarea value={local.paragraph1} onChange={e => u('paragraph1', e.target.value)} rows={3} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none" /></div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">2. Paragraf</label><textarea value={local.paragraph2} onChange={e => u('paragraph2', e.target.value)} rows={3} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none" /></div>
        <ImageUploader
          label="Bölüm Görseli"
          value={local.image_url}
          onChange={val => u('image_url', val)}
          previewHeight="h-40"
          hint="Önerilen boyut: 800×600px"
        />
      </div>
      <SaveButton saved={saved} onSave={handleSave} />
    </div>
  );
}
